module.exports = __webpack_public_path__ + "static/media/minus.efb45da0.svg";